import { Loader2 } from 'lucide-react';

/** PlanTakeover's footer while a video starts: /start shows it, and the studio keeps it until Ivy first answers. */
export const PlanWorking = () => (
  <div className="flex h-11 items-center justify-between rounded-[var(--b-radius-card)] border border-b-line bg-b-panel px-4 text-b-control text-b-t3">
    Ivy is working…
    <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
  </div>
);
